/**
 * Kalshi market deep-links (web routing as of 2026-06-10).
 *
 * The only working form is THREE path segments + optional query:
 *
 *   https://kalshi.com/markets/<series_lc>/<series_lc>/<event_ticker_lc>?op_market_ticker=<MARKET_TICKER_UC>
 *
 * - Segment 2 is ignored by Kalshi's router (it redirects to the canonical
 *   slug) — we use the lowercased series ticker.
 * - Segment 3 must be the EVENT ticker (lowercase).
 * - `?op_market_ticker=` (uppercase market ticker) selects the specific
 *   market within the event; appended only when the market ticker differs
 *   from the event ticker.
 *
 * The stored `prediction_pairs.siteB.marketUrl` is backfilled to this same
 * format; prefer the stored `eventTicker` when the caller has it and fall
 * back to the heuristic below otherwise.
 */

/**
 * Derive the event ticker from a full market ticker.
 *
 * Split on `-`: with 3+ segments the event is everything but the last
 * segment; with 2 or fewer segments the market ticker IS the event ticker.
 *
 *   KXFIFAWGAME-26JUN09SWEITA-SWE → KXFIFAWGAME-26JUN09SWEITA
 *   KXMLBRFI-26JUN101835SEABAL   → KXMLBRFI-26JUN101835SEABAL
 *   KXBTC-26-100K                → KXBTC-26
 */
export const kalshiEventTickerFromMarketTicker = (
  marketTicker: string,
): string => {
  const segments = marketTicker.split("-");
  if (segments.length >= 3) {
    return segments.slice(0, -1).join("-");
  }
  return marketTicker;
};

export const buildKalshiMarketUrl = (
  marketTicker: string,
  eventTicker?: string | null,
): string => {
  const event = (
    eventTicker || kalshiEventTickerFromMarketTicker(marketTicker)
  ).toLowerCase();
  const series = event.split("-")[0];
  const base = `https://kalshi.com/markets/${series}/${series}/${event}`;
  const market = marketTicker.toUpperCase();
  if (market === event.toUpperCase()) return base;
  return `${base}?op_market_ticker=${market}`;
};
